module.exports = __webpack_public_path__ + "static/media/metamask_fox.2442aad7.svg";